/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Button, Grid, Segment, Popup, Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { logAction } from "../actions/changeActiveItemActions";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

// Regex to match agains the form input to know if the user typed an IP or a device name
const ipRegex = new RegExp("^[0-2][0-9.]*$");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const UtilsInstance = new Utils();

class Inventory extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,

      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      numOfDevices: "",

      isColumnClicked: false,
    };
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num2 - num1;
        }),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by mac ascending
    else if (clickedColumn === "mac" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "id",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by mac descending
    else if (clickedColumn === "mac" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "id",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by name ascending
    else if (clickedColumn === "name" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "product_name",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by name descending
    else if (clickedColumn === "name" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "product_name",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by vendor_id ascending
    else if (clickedColumn === "vendorId" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "vendor_id",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by vendor_id descending
    else if (clickedColumn === "vendorId" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "vendor_id",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by revision ascending
    else if (clickedColumn === "revision" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "revision",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by revision descending
    else if (clickedColumn === "revision" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "revision",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by revision ascending
    else if (clickedColumn === "productCode" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "product_code",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by revision descending
    else if (clickedColumn === "productCode" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "product_code",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by the serial ascending
    else if (clickedColumn === "serial" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "serial_number",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by the serial descending
    else if (clickedColumn === "serial" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "serial_number",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by the number of faults ascending
    else if (clickedColumn === "type" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "device_type",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by the number of faults descending
    else if (clickedColumn === "type" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "device_type",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
  }

  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];
    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].socket_sin_address === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].id != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].id.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleProductNameSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].product_name != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].product_name.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip, mac or type the user has typed in the form
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput !== "") {
      this.handleProductNameSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = () => {
    // Retrieve devices list only if the input form is empty and the user
    // didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      // then get the live list data itself
      fetch(Constants.REQUEST_IP_ADDRESS + "listIdentity", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({
          devices: data.sort((a, b) => {
            const num1 = Number(a.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            const num2 = Number(b.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            return num1 - num2;
          }),
          originalDevices: data.sort((a, b) => {
            const num1 = Number(a.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            const num2 = Number(b.socket_sin_address.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            return num1 - num2;
          })
        }));

      fetch(Constants.REQUEST_IP_ADDRESS + "deviceStatistics", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({ numOfDevices: data.devices }));
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  exportInventoryAsCSV = () => {
    let csvText = Strings.INVENTORY_CSV_HEADER;

    for (let i = 0; i < this.state.originalDevices.length; i++) {

      let name = this.state.originalDevices[i].product_name.replace(/,/g, "");
      let vendorId = this.state.originalDevices[i].vendor_id.replace(/,/g, "");
      let deviceType = this.state.originalDevices[i].device_type.replace(/,/g, "");

      csvText += this.state.originalDevices[i].socket_sin_address + ","
        + this.state.originalDevices[i].id + ","
        + name + ","
        + vendorId + ","
        + this.state.originalDevices[i].revision + ","
        + this.state.originalDevices[i].product_code + ","
        + this.state.originalDevices[i].serial_number + ","
        + deviceType + "\n";
    }

    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* Criação do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.INVENTORY_CSV_EXPORT_NAME;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.id}>
        <Table.Cell verticalAlign="middle">{device.socket_sin_address}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.id}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.product_name}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.vendor_id}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.revision}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.product_code}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.serial_number}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.device_type}</Table.Cell>
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <Grid columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>
            <Grid.Column>
              <p><b>{Strings.NUM_OF_DEVICES}</b>{this.state.numOfDevices}</p>
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.INVENTORY_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Segment id="legend-segment" basic textAlign="right">

                <Button
                  content={Strings.EXPORT_CSV}
                  color="teal"
                  onClick={this.exportInventoryAsCSV} />

              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={column === "ip" ? direction : null}
                onClick={this.handleSort("ip")}>
                {Strings.IP}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "mac" ? direction : null}
                onClick={this.handleSort("mac")}>
                {Strings.MAC}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "name" ? direction : null}
                    onClick={this.handleSort("name")}>
                    {Strings.PRODUCT_NAME}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.PRODUCT_NAME_POPUP_1}</p>
                  <p>{Strings.PRODUCT_NAME_POPUP_2}</p>
                  <p>{Strings.PRODUCT_NAME_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "vendorId" ? direction : null}
                    onClick={this.handleSort("vendorId")}>
                    {Strings.VENDOR_ID}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.VENDOR_ID_POPUP_1}</p>
                  <p>{Strings.VENDOR_ID_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "revision" ? direction : null}
                    onClick={this.handleSort("revision")}>
                    {Strings.REVISION}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.REVISION_POPUP_1}</p>
                  <p>{Strings.REVISION_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "productCode" ? direction : null}
                    onClick={this.handleSort("productCode")}>
                    {Strings.PRODUCT_CODE}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.PRODUCT_CODE_1}</p>
                  <p>{Strings.PRODUCT_CODE_2}</p>
                  <p>{Strings.PRODUCT_CODE_3}</p>
                  <p>{Strings.PRODUCT_CODE_4}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "serial" ? direction : null}
                    onClick={this.handleSort("serial")}>
                    {Strings.SERIAL_NUMBER}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.SERIAL_NUMBER_POPUP_1}</p>
                  <p>{Strings.SERIAL_NUMBER_POPUP_2}</p>
                  <p>{Strings.SERIAL_NUMBER_POPUP_3}</p>
                  <p>{Strings.SERIAL_NUMBER_POPUP_4}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "type" ? direction : null}
                    onClick={this.handleSort("type")}>
                    {Strings.DEVICE_TYPE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.DEVICE_TYPE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.DEVICE_TYPE_POPUP_1}</p>
                  <p>{Strings.DEVICE_TYPE_POPUP_2}</p>
                  <p>{Strings.DEVICE_TYPE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" sortable striped celled fixed selectable textAlign="center">
            <Table.Body>{devices}</Table.Body>
          </Table>

        </div>
      </div >
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const mapActionsToProps = {
  onChangeLog: logAction
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default connect(null, mapActionsToProps)(withRouter(Inventory));
